import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: LegalModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-33">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 z-[100] backdrop-blur-sm" data-id="element-34" />
          <div className="fixed inset-0 z-[101] flex items-center justify-center p-4 pointer-events-none" data-id="element-35">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col pointer-events-auto" data-id="element-36">
              <div className="flex items-center justify-between p-4 border-b border-gray-100" data-id="element-37">
                <h2 className="text-xl font-bold text-gray-900" data-id="element-38">{title}</h2>
                <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-39">
                  <X className="w-5 h-5" data-id="element-40" />
                </button>
              </div>
              <div className="p-6 overflow-y-auto text-gray-600 text-sm leading-relaxed space-y-4" data-id="element-41">
                {content}
              </div>
              <div className="p-4 border-t border-gray-100 flex justify-end" data-id="element-42">
                <button onClick={onClose} className="px-6 py-2 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition-colors" data-id="element-43">
                  Close
                </button>
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}